import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const gridDemo = {
    code:
`<GridRow style={{ background: "#d4e0fd" }}>
    <GridCell style={{ background: "#ffebee" }}>Default width</GridCell>
    <GridCell span={4} style={{ background: "#ffebee" }}>Hi</GridCell>
    <GridCell span={4} style={{ background: "#ffebee" }}>Hello</GridCell>
    <GridCell span={4} style={{ background: "#ffebee" }}>Hey</GridCell>
</GridRow>`
};

export const GridDemo: FunctionComponent = () => {
    return (
        <Demo demo={gridDemo}>
            <ComponentProps componentName="Grid" />
            <ComponentProps componentName="GridCell" />
            <ComponentProps componentName="GridRow" />
        </Demo>
    );
};
